(ns frontend.workaround
  (:require
   [common.util :as cu :refer [kw->str]]
   goog.math.Long
   goog.math.Integer
   [goog.object :as gobject]
   [goog.Uri])
  (:import
   [goog.string StringBuffer]))

;;; https://dev.clojure.org/jira/browse/CLJS-2215
;;; https://github.com/clojure/clojurescript/commit/e3a9f0cd8511dcfe0c80f37834b5aa32c7b058d4

;;; !!! REMOVE THIS NAMESPACE WHEN FIX WILL BE AVAILABLE IN CLOJURESCRIPT CORE !!!

(declare clj->js-workaround)

(defn key->js-workaround
  ([k] (key->js-workaround k clj->js-workaround))
  ([k primitive-fn]
   (cond
     (satisfies? IEncodeJS k) (-clj->js k)
     (or (string? k)
         (number? k)
         (keyword? k)
         (symbol? k))
     (primitive-fn k)
     :else (pr-str k))))

(defn clj->js-workaround
  "Recursively transforms ClojureScript values to JavaScript.
  sets/vectors/lists become Arrays, Keywords and Symbol become Strings,
  Maps become Objects. Arbitrary keys are encoded to by key->js-workaround."
  [x &
   {:keys [keyword-fn]
    :or   {keyword-fn kw->str}}]
  (letfn [(keyfn [k] (key->js-workaround k thisfn))
          (thisfn [x]
            (cond
              (nil? x) nil
              (satisfies? IEncodeJS x) (-clj->js x)
              (keyword? x) (keyword-fn x)
              (symbol? x) (str x)
              (map? x) (let [m (js-obj)]
                         (doseq [[k v] x]
                           (gobject/set m (keyfn k) (thisfn v)))
                         m)
              (coll? x) (let [arr (array)]
                          (doseq [x (map thisfn x)]
                            (.push arr x))
                          arr)
              :else x))]
    (thisfn x)))
